import i18n from "i18next";

i18n.use("vn").init({
    // we init with resources
    resources: {
        en: {
            translations: {
                Login: "Login",
                Register: "Register",
                Logout: "Logout",
                Fullname: "Fullname",
                Birthday: "Birthday",
                IdentityCard: "Identity Card",
                Address: "Address",
                Email: "Email",
                Password: "Password",
                ConfirmPassword: "Confirm password",
                PhoneNumber: "Phone Number",
                BikeModel: "Bike Model",
                Cancel: "Cancel",
                ShortCampaign: "Campaign",
                Campaign: "Advertising Campaign",
                Journey: "Journey",
                SignUp: "SignUp",
                SignUped: "Has SignUp",
                StartDate: "Start date",
                EndDate: "End date",
                RangeTime: "Range Time",
                TotalDriver: "Total Driver",
                RemainDriver: "Remain Driver",
                TotalHour: "Total Hour",
                RemainHour: "Remain Hour",
                UnitHour: "hour",
                No: "No",
                Day: "Day",
                ZoneStart: "Zone start",
                ZoneEnd: "Zone end",
                StartTime: "Start time",
                EndTime: "Start time",
                TotalTimer: "Total time",
                Timer: "Time",
                TotalEarn: "Total Earn",
                Dashboard: "Dashboard",
                Zone: "Zone",
                i18n: "This is I18n",
                NotEnoughMoney: "Campaign budget exceeds your account balance.",
                Budget: "Budget",
                Displays: "Number of displays",
                ExpectedImpressions: "Expected impressions",
                UsedBudget: "Used budget",
                Impressions: "Real impressions",
                CPI: "CPI",
                CampaignState_ToBeStarted: "Start",
                CampaignState_Finished: "Finished",
                WaitingForVerification_Title: "Verify account",
                WaitingForVerification_Message:
                    "Tài khoản của bạn đang được thiết lập. Sau khi bạn bấm vào đường dẫn xác nhận trong email xác nhận của chúng tôi, tài khoản của bạn sẽ được chính thức đưa vào hoạt động.",
                Thank: "Thank you!",
                AddCampaign: "New campaign",
                CampaignName: "Campaign name",
                Date: "Date",
                FromDate: "From date",
                ToDate: "To date",
                UploadBanner: "Upload banner",
                Start: "Start",
                SaveDraft: "Save draft",
                SubmitDraftCampaign: "Create campaign",
                New: "New",
                Running: "Running",
                Finished: "Finished",
                Cost: "Cost",
                Balance: "Balance",
                Approved: "Approved campaign",
                EditingRequired:
                    "Chiến dịch không được duyệt, vui lòng chỉnh sửa lại thông tin hoặc liên lạc với chúng tôi qua email team@adzrunner.com",
                Pause: "Pause",
                Continue: "Continue",
                Stop : "Stop",
                Edit: "Edit",
                WaitingForApproval: "Waiting for approval",
                Loading: "Loading data.......",
                NoData: "No data",
                Profile: "Profile",
                Update: "Update",
                AccountName: "Account name",
                OldPass: "Old password",
                NewPass: "New password",
                RememberPass: "Remember password",
                ForgetPass: "Forget password?",
                Slogan: "A LOCALIZED DIGITAL ADS PLATFORM",
                InvalidCampaignName: "Campaign name is required",
                InvalidCampaignDateRange: "Date range is required",
                InvalidCampaignZones: "Zones are required",
                InvalidTimeSlots_Empty: "Time ranges are required",
                InvalidTimeSlots_Invalid: "Invalid time slot",
                InvalidDisplayNumber:
                    "Number of displays must be greater than 0",
                InvalidBanners: "Ad content is required",
                Notification:"Notification",
                NoNotification:"No new notification",
                ReturnMoney:"Return Money",
                ViewByDate:"Chart View By Date",
                ViewByHour:"Chart View By Hour",
                ViewByArea:"Chart View By Area",
                ViewByDateArea:"Chart View By Date x Area",
                ViewByDateTime:"Chart View By Date x Time",
                ViewByAreaTime:"Chart View By Area x Time"
            }
        },
        vn: {
            translations: {
                Login: "Đăng nhập",
                Register: "Đăng ký",
                Logout: "Đăng xuất",
                Fullname: "Họ và Tên",
                Birthday: "Ngày sinh",
                IdentityCard: "CMND",
                Address: "Địa chỉ",
                Email: "Email",
                Password: "Mật khẩu",
                ConfirmPassword: "Xác nhận mật khẩu",
                PhoneNumber: "Điện thoại",
                BikeModel: "Dòng xe",
                Cancel: "Hủy",
                ShortCampaign: "Chiến Dịch",
                Campaign: "Chiến Dịch Quảng Cáo",
                Journey: "Hành Trình",
                SignUp: "Đăng ký",
                SignUped: "Đã đăng ký",
                StartDate: "Bắt đầu",
                EndDate: "Kết thúc",
                RangeTime: "Khung giờ",
                TotalDriver: "Tổng tài xế",
                RemainDriver: "Cần thêm",
                TotalHour: "Thời lượng",
                RemainHour: "Thời gian còn lại",
                UnitHour: "giờ",
                No: "Stt",
                Day: "Ngày",
                ZoneStart: "Bắt đầu",
                ZoneEnd: "Kết thúc",
                StartTime: "Thời điểm bắt đầu",
                EndTime: "Thời điểm kết thúc",
                TotalTimer: "Thời gian đi được",
                Timer: "Thời gian",
                TotalEarn: "Thu nhập",
                Dashboard: "Tổng quan",
                Zone: "Khu vực",
                i18n: "Đây là I18n",
                NotEnoughMoney:
                    "Số tiền trong tài khoản không đủ để bắt đầu chiến dịch.",
                Budget: "Ngân sách",
                Displays: "Số lượt hiển thị",
                ExpectedImpressions: "Lượt xem dự kiến",
                UsedBudget: "Đã sử dụng",
                Impressions: "Lượt xem thực tế",
                CPI: "CPI",
                CampaignState_ToBeStarted: "Bắt đầu",
                CampaignState_Finished: "Hoàn tất",
                WaitingForVerification_Title: "Chờ xác nhận tài khoản",
                WaitingForVerification_Message:
                    "Tài khoản của bạn đang được thiết lập. Sau khi bạn bấm vào đường dẫn xác nhận trong email xác nhận của chúng tôi, tài khoản của bạn sẽ được chính thức đưa vào hoạt động.",
                Thank: "Xin cảm ơn!",
                AddCampaign: "Chiến dịch mới",
                CampaignName: "Tên chiến dịch",
                Date: "Ngày",
                FromDate: "Từ ngày",
                ToDate: "Đến ngày",
                UploadBanner: "Đăng hình quảng cáo",
                Start: "Bắt đầu",
                SaveDraft: "Lưu nháp",
                SubmitDraftCampaign: "Tạo chiến dịch",
                New: "Mới",
                Running: "Đang hoạt động",
                Finished: "Kết thúc",
                Cost: "Chi phí",
                Balance: "Số tiền trong TK",
                Approved: "Chiến dịch đã được duyệt",
                EditingRequired:
                    "Chiến dịch không được duyệt, vui lòng chỉnh sửa lại thông tin hoặc liên lạc với chúng tôi qua email team@adzrunner.com",
                Pause: "Tạm dừng",
                Continue: "Tiếp tục",
                Stop : "Kết Thúc",
                Edit: "Chỉnh sửa",
                WaitingForApproval: "Đang chờ xét duyệt",
                Loading: "Đang tải dữ liệu.......",
                NoData: "Không có dữ liệu",
                Profile: "Thông tin tài khoản",
                Update: "Cập nhật",
                AccountName: "Tên tài khoản",
                OldPass: "Mật khẩu cũ",
                NewPass: "Mật khẩu mới",
                RememberPass: "Nhớ mật khẩu",
                ForgetPass: "Quên mật khẩu?",
                Slogan: "A LOCALIZED DIGITAL ADS PLATFORM", //"NỀN TẢNG QUẢNG CÁO KỸ THUẬT SỐ THEO VÙNG",
                InvalidCampaignName: "Bạn chưa điền tên chiến dịch",
                InvalidCampaignDateRange: "Bạn chưa chọn ngày cho chiến dịch",
                InvalidCampaignZones: "Bạn chưa chọn khu vực",
                InvalidTimeSlots_Empty: "Bạn chưa chọn khung giờ cho chiến dịch",
                InvalidTimeSlots_Invalid: "Khung thời gian không hợp lệ",
                InvalidDisplayNumber: "Số lượt hiển thị phải lớn hơn 0",
                InvalidBanners: "Bạn chưa đăng hình/video quảng cáo",
                Notification:"Tin Nhắn",
                NoNotification:"Không có tin nhắn mới",
                ReturnMoney:"Hoàn trả",
                OverBudget:"Kết thúc",
                OverDate:"Hết hạn",

                ViewByDate:"Số Lượt Hiển Thị Theo Ngày",
                ViewByHour:"Số Lượt Hiển Thị Theo Khung Giờ",
                ViewByArea:"Số Lượt Hiển Thị Theo Khu Vực",
                ViewByDateArea:"Số Lượt Hiển Thị Theo Ngày x Khu Vực",
                ViewByDateTime:"Số Lượt Hiển Thị Theo Ngày x Khung Giờ",
                ViewByAreaTime:"Số Lượt Hiển Thị Theo Khu Vực x Khung Giờ",
                ViewByDriver:"Số Thiết Bị Hoạt Động",
                ViewByDriverDisplay:"Số Lượt Hiển Thị Theo Thiết Bị",

            }
        }
    },
    fallbackLng: "vn",

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false, // we use content as keys

    interpolation: {
        escapeValue: false, // not needed for react!!
        formatSeparator: ","
    },

    react: {
        wait: true
    }
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js